export const rules = {
  username: {
    required: true,
  },
  password: {
    required: true,
  }
}